import { useState } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import { Light as SyntaxHighlighter } from 'react-syntax-highlighter'
import xml from 'react-syntax-highlighter/dist/cjs/languages/hljs/xml'
import javascript from 'react-syntax-highlighter/dist/cjs/languages/hljs/javascript'
import solarized from 'react-syntax-highlighter/dist/cjs/styles/hljs/solarized-dark'
import TooltipFlash from 'components/misc/TooltipFlash'
import copy from 'copy-to-clipboard'
import styles from './styles/CodeSnippet.css'

SyntaxHighlighter.registerLanguage('xml', xml)
SyntaxHighlighter.registerLanguage('javascript', javascript)

export const CopyWidget = ({ snippet, trimNewlines, flashTime = 1000 }) => {
  const [flash, setFlash] = useState()

  const handleCopy = () => {
    const strToCopy = trimNewlines
      ? snippet
          .replace(/\n\s+/g, ' ')
          .replace(/\s+/g, ' ')
          .replace(/>\s</g, '><')
          .trim()
      : snippet
    copy(strToCopy)
    setFlash({})
  }

  return (
    <TooltipFlash
      className={styles.copyWidget}
      tooltipClassName={styles.tooltip}
      content='Copied!'
      flash={flash}
      flashTime={flashTime}
      onClick={handleCopy}
      role='button'
      tabIndex='0'
      aria-label='Copy'
    >
      <i className='fa fa-copy' />
    </TooltipFlash>
  )
}

const CodeSnippet = ({ className, snippet, language = 'xml', trimNewlines = true }) => {
  return (
    <div className={classNames(styles.codeSnippet, className)}>
      <SyntaxHighlighter language={language} style={solarized} customStyle={{ padding: '0', margin: '0' }}>
        {snippet}
      </SyntaxHighlighter>

      <CopyWidget snippet={snippet} trimNewlines={trimNewlines} />
    </div>
  )
}

CodeSnippet.propTypes = {
  snippet: PropTypes.string.isRequired,
  className: PropTypes.string,
  trimNewlines: PropTypes.bool
}

export default CodeSnippet
